import produce from 'immer';
import {
	SEARCH_HS_CODE_FAILED,
	SEARCH_HS_CODE_FULFILLED,
	SEARCH_HS_CODE_PENDING,
} from '../constants/actions/customsActions';
import { ICustomsReducer } from '../interfaces/customs/hsCodes';

const initialValues: ICustomsReducer = {
	hsCodeSearchResults: null,
	hsCodeSearchResultsLoading: false,
	hsCodeSearchResultsError: null,
};

const customsReducer = produce((draft: ICustomsReducer, action) => {
	switch (action.type) {
		case SEARCH_HS_CODE_PENDING: {
			draft.hsCodeSearchResultsLoading = true;
			draft.hsCodeSearchResultsError = null;
			break;
		}
		case SEARCH_HS_CODE_FULFILLED: {
			draft.hsCodeSearchResultsLoading = false;
			draft.hsCodeSearchResultsError = null;
			draft.hsCodeSearchResults = action.payload;
			break;
		}
		case SEARCH_HS_CODE_FAILED: {
			// payload is the translation key of the error to show.
			draft.hsCodeSearchResultsLoading = false;
			draft.hsCodeSearchResultsError = action.payload;
			break;
		}
		default:
			break;
	}
}, initialValues);

export default customsReducer;
